//Dependecies
import React from 'react';

const InfoPage = () =>
{
  return(
    <React.Fragment>
      <div className = "relative bg-blue-50 select-none">
        <div 
          className = "relative pt-16 pb-32 flex content-center items-center justify-cente " 
          style = 
            {{
              minHeight : '75vh',
            }}
        >
          <div 
            className = "absolute top-0 w-full h-full"
          >
            <img
              src = "https://firebasestorage.googleapis.com/v0/b/spot360vlog.appspot.com/o/Thumbnails%2Finfo.jpg?alt=media&token=0513d21b-a1c9-4083-9d43-07a91adcf1e2"
              className = "absolute top-0 w-full h-full object-center object-cover"
              alt = ""
            />
            <span             
              className = "w-full h-full absolute opacity-75 bg-black"
            />
          </div>

          <div className = "container relative mx-auto">
            <div className = "items-center flex flex-wrap">
              <div className = "w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
                <h1 className = "text-white font-semibold text-3xl lg:text-5xl sm:text-4xl">
                  CONSTRUVISOR
                </h1>
                <p className = "mt-4 text-white text-base md:text-lg ">
                  Aquí podrás mostrar todo tu PORTAFOLIO de construcciones, materiales, remodelaciones y todo lo relacionado con la construcción, con
                  panoramas 360, interactivos y con la opción de mostrar a todos los participaron en ellos.
                </p>
              </div>
            </div>
          </div>

          <div 
            className = "top-auto bottom-0 left-0 right-0 absolute" 
            style = 
            {{
              transform : 'translateZ(0px)',
              height    : '75px'
            }}
          >
            <svg 
              className = "absolute  bottom-0 overflow-hidden"
              xmlns = "http://www.w3.org/2000/svg" 
              preserveAspectRatio = "none" 
              version = "1.1" 
              viewBox = "0 0 2560 100"
              x = "0"
              y = "0"
            >
              <polygon 
                className = "text-blue-50 fill-current"
                points = "2560 0 2560 100 0 100"
              />
            </svg>
          </div>  
        </div>
        
        <section className = "pb-10 bg-blue-50 -mt-24">
          <div className = "container mx-auto px-4 max-w-6xl">
            <div className = "flex flex-wrap">
              <div className = "lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
                <div className = "relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className = "px-4 py-5 flex-auto">
                    <div className = "text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-red-400 text-lg">
                      <i className = "fas fa-users"></i>
                    </div>
                    <h6 className = "text-xl font-semibold">
                      Créditos
                    </h6>
                    <p className = "mt-2 mb-4 text-blueGray-500">
                      Todas las personas y negocios que participaron en cada uno de los proyectos.                      
                    </p>
                  </div>
                </div>
              </div>

              <div className = "w-full md:w-4/12 px-4 text-center">
                <div className = "relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className = "px-4 py-5 flex-auto">
                    <div className = "text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-sky-400 text-lg">
                      <i className = "fas fa-camera"></i>
                    </div>
                    <h6 className = "text-xl font-semibold">
                      Fotografía 360
                    </h6>
                    <p className = "mt-2 mb-4 text-blueGray-500">
                      Tus clientes podrán visitar tus proyectos y tu portafolio de forma virtual.
                    </p>
                  </div>
                </div>
              </div>

              <div className = "pt-6 w-full md:w-4/12 px-4 text-center">
                <div className = "relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className = "px-4 py-5 flex-auto">
                    <div className = "text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-emerald-400 text-lg">
                      <i className = "fas fa-share"></i>
                    </div>
                    <h6 className = "text-xl font-semibold">
                      Fácil de compartir
                    </h6>
                    <p className = "mt-2 mb-4 text-blueGray-500">
                      Hecho para poder ser compartido con facilidad.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>         

          <footer className = "relative  pt-8 pb-6 mt-1">
            <div className = "container mx-auto px-4">
              <div className = "flex flex-wrap items-center md:justify-between justify-center">
                <div className = "w-full md:w-full px-4 mx-auto text-center">
                <a 
                  href = "/" 
                  className=" bg-transparent hover:bg-black text-black font-semibold hover:text-grey-800 py-2 px-4 border-2 border-black hover:border-transparent rounded "
                >
                  PÁGINA PRINCIPAL
                </a>
                </div>
              </div>
            </div>
          </footer>

          <footer className = "relative  pt-8 pb-6 mt-1">
            <div className = "container mx-auto px-4">
              <div className = "flex flex-wrap items-center md:justify-between justify-center">
                <div className = "w-full md:w-full px-4 mx-auto text-center">
                  <div className = "text-sm text-blueGray-500 font-semibold py-1">
                    Creado por

                    &nbsp;

                    <a 
                      href      = "https://www.tiktok.com/@viveen360" 
                      className = "text-blueGray-500 hover:text-gray-800" 
                      target    = "_blank"
                      rel       = "noopener noreferrer"
                    >
                      VIVE EN 360
                    </a> 
                    
                    &nbsp;

                    by
                    
                    &nbsp;

                    <a 
                      href      = "https://www.instagram.com/entornoceo"
                      className = "text-blueGray-500 hover:text-blueGray-800"
                      target    = "_blank"
                      rel       = "noopener noreferrer"
                    >
                      Javier Hernández
                    </a>
                    .
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </section>
      </div>
    </React.Fragment>
  );
}

export default InfoPage;